export const NOTICE = "NOTICE";
export const NOTICE_SUCCESS = "NOTICE_SUCCESS";
export const NOTICE_FAILED = "NOTICE_FAILED";

export const ADD_NOTICE = "ADD_NOTICE";
export const ADD_NOTICE_SUCCESS = "ADD_NOTICE_SUCCESS";
export const ADD_NOTICE_FAILED = "ADD_NOTICE_FAILED";

export const UPDATE_NOTICE = "UPDATE_NOTICE";
export const UPDATE_NOTICE_SUCCESS = "UPDATE_NOTICE_SUCCESS";
export const UPDATE_NOTICE_FAILED = "UPDATE_NOTICE_FAILED";